export const TitleBar = require('./TitleBar').default;
export const DocTitle = require('./DocTitle').default;
export const ServiceDialog = require('./ServiceDialog').default;

export default {
  TitleBar,
  DocTitle,
  ServiceDialog,
};



// WEBPACK FOOTER //
// ./src/common/components/Layout/StandardPageTemplate/Context/index.js